import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ReplaceIntakeFormRequest } from '@/definitions/intakeForm'
import { ReplaceIntakeForm } from '@/services/IntakeFormService'
import { isTimeoutError } from '@/utils/apiErrors'

interface ReplaceIntakeFormVariables {
  baseFormId: string
  data: ReplaceIntakeFormRequest
  orgId: string
}

export const useReplaceIntakeForm = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ orgId, baseFormId, data }: ReplaceIntakeFormVariables) =>
      ReplaceIntakeForm(orgId, baseFormId, data),
    meta: { suppressGlobalError: true },
    onSuccess: (_form, { orgId }) => {
      queryClient.invalidateQueries({ queryKey: ['intakeForms', orgId] })
    },
    onError: (error, { orgId }) => {
      if (isTimeoutError(error)) {
        queryClient.invalidateQueries({ queryKey: ['intakeForms', orgId] })
      }
    },
  })
}
